module.exports = __webpack_public_path__ + "static/media/mp-online-beta-welcome-image.c80f4a84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mp-online-beta-welcome-image.svg
// module id = 186
// module chunks = 0